module.exports = __webpack_public_path__ + "img/home1.c6750707.svg";